<template>
    <div>
        <div class="flex flex-wrap items-center membership-layout-container">
            <div class="mr-2">
              <span class="text-sm" style="color: grey">
                 {{ activeElement.value.name }}
              </span>
            </div>
          </div>
    </div>
</template>
<script>
export default {
  name: 'Breadcrumb-Pages',
  props:{
    activeElement: {
      required: true,
    },
  }
}
</script>
